// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f90d79b","732":"d7ec55ad","977":"59f9b171"}[chunkId] + ".chunk.js";
};